module.exports = __webpack_public_path__ + "img/baojing.9103dc1e.png";